import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function validateCustomProfile(currentString: any, wellTd: number): ValidatorFn {


  return (control: AbstractControl): ValidationErrors | null => {
    const gridData = control.value;
    let lastPointAboveShoe;
    if (gridData) {
      const margin = 0.0001;
      const lastDepth = gridData[gridData.length - 1]?.measuredDepth;
      const firstDepth = gridData[0]?.measuredDepth;
      lastPointAboveShoe = lastDepth < currentString?.shoeMd - margin || !lastDepth || firstDepth > currentString.hangerMd + margin || lastDepth > wellTd + margin;
    }

    return lastPointAboveShoe ? { lastPointAboveShoe: true } : null;
  }
}

export function validateCustomUdtProfile(totalDepth: number, topPoint: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const gridData = control.value;
    let lastPointAboveShoe;
    if (gridData) {
      const lastDepth = gridData[gridData.length - 1]?.trueVerticalDepth;
      const firstDepth = gridData[0]?.trueVerticalDepth;
      const margin = 0.0001;
      lastPointAboveShoe =
        !lastDepth ||
        lastDepth < totalDepth - margin ||
        firstDepth > totalDepth + margin ||
        lastDepth < topPoint - margin;

    }

    return lastPointAboveShoe ? { lastPointAboveShoe: true } : null;
  }
}